// This file is AUTOGENERATED, do not edit it manually!!!

import { inlineEdit as inlineEditde } from './inlineEditResx.de';
import { inlineEdit as inlineEditen } from './inlineEditResx.en';
import { inlineEdit as inlineEditen_risk } from './inlineEditResx.en_risk';
import { inlineEdit as inlineEdites } from './inlineEditResx.es';
import { inlineEdit as inlineEditfr } from './inlineEditResx.fr';
import { inlineEdit as inlineEditit } from './inlineEditResx.it';
import { inlineEdit as inlineEditnl } from './inlineEditResx.nl';
import { inlineEdit as inlineEditpl } from './inlineEditResx.pl';
import { inlineEdit as inlineEditpt } from './inlineEditResx.pt';
import { inlineEdit as inlineEditru } from './inlineEditResx.ru';
import { inlineEdit as inlineEditsk } from './inlineEditResx.sk';
import { inlineEdit as inlineEditsv } from './inlineEditResx.sv';
import { inlineEdit as inlineEdittr } from './inlineEditResx.tr';

const langMap: { [k: string]: Partial<typeof inlineEditen> } = {
    de: inlineEditde,
    en: inlineEditen,
    en_risk: inlineEditen_risk,
    es: inlineEdites,
    fr: inlineEditfr,
    it: inlineEditit,
    nl: inlineEditnl,
    pl: inlineEditpl,
    pt: inlineEditpt,
    ru: inlineEditru,
    sk: inlineEditsk,
    sv: inlineEditsv,
    tr: inlineEdittr,
};

/* tslint:disable: max-line-length */
export const inlineEditResx = {
    get action_has_been_successfully_undone() {
        return langMap[ep.resxCulture].action_has_been_successfully_undone || langMap.en.action_has_been_successfully_undone;
    },
    get action_has_not_been_successfully_undone() {
        return langMap[ep.resxCulture].action_has_not_been_successfully_undone || langMap.en.action_has_not_been_successfully_undone;
    },
    get action_will_be_undo_message() {
        return langMap[ep.resxCulture].action_will_be_undo_message || langMap.en.action_will_be_undo_message;
    },
    get ActivityChildrenActualHours_Text() {
        return langMap[ep.resxCulture].ActivityChildrenActualHours_Text || langMap.en.ActivityChildrenActualHours_Text;
    },
    get ActivityChildrenEstimatedHours_Text() {
        return langMap[ep.resxCulture].ActivityChildrenEstimatedHours_Text || langMap.en.ActivityChildrenEstimatedHours_Text;
    },
    get ActivityOwnBudget_Text() {
        return langMap[ep.resxCulture].ActivityOwnBudget_Text || langMap.en.ActivityOwnBudget_Text;
    },
    get ActivityOwnEstimatedHours_Text() {
        return langMap[ep.resxCulture].ActivityOwnEstimatedHours_Text || langMap.en.ActivityOwnEstimatedHours_Text;
    },
    get ActivitySubactivitiesBudget_Text() {
        return langMap[ep.resxCulture].ActivitySubactivitiesBudget_Text || langMap.en.ActivitySubactivitiesBudget_Text;
    },
    get ActualCompletion_Text() {
        return langMap[ep.resxCulture].ActualCompletion_Text || langMap.en.ActualCompletion_Text;
    },
    get ActualHours_Total_Text() {
        return langMap[ep.resxCulture].ActualHours_Total_Text || langMap.en.ActualHours_Total_Text;
    },
    get AddTimeEntry_Text() {
        return langMap[ep.resxCulture].AddTimeEntry_Text || langMap.en.AddTimeEntry_Text;
    },
    get AddUser_Text() {
        return langMap[ep.resxCulture].AddUser_Text || langMap.en.AddUser_Text;
    },
    get AddWeeklyTime_Text() {
        return langMap[ep.resxCulture].AddWeeklyTime_Text || langMap.en.AddWeeklyTime_Text;
    },
    get Apply() {
        return langMap[ep.resxCulture].Apply || langMap.en.Apply;
    },
    get Assignees_Text() {
        return langMap[ep.resxCulture].Assignees_Text || langMap.en.Assignees_Text;
    },
    get BudgetedCost_Text() {
        return langMap[ep.resxCulture].BudgetedCost_Text || langMap.en.BudgetedCost_Text;
    },
    get BudgetPadding_Text() {
        return langMap[ep.resxCulture].BudgetPadding_Text || langMap.en.BudgetPadding_Text;
    },
    get BudgetTotal_Text() {
        return langMap[ep.resxCulture].BudgetTotal_Text || langMap.en.BudgetTotal_Text;
    },
    get Cancel() {
        return langMap[ep.resxCulture].Cancel || langMap.en.Cancel;
    },
    get Close() {
        return langMap[ep.resxCulture].Close || langMap.en.Close;
    },
    get Combobox_Add() {
        return langMap[ep.resxCulture].Combobox_Add || langMap.en.Combobox_Add;
    },
    get Combobox_KeepTyping() {
        return langMap[ep.resxCulture].Combobox_KeepTyping || langMap.en.Combobox_KeepTyping;
    },
    get Combobox_MultipleSelectDefault() {
        return langMap[ep.resxCulture].Combobox_MultipleSelectDefault || langMap.en.Combobox_MultipleSelectDefault;
    },
    get Combobox_NoResults() {
        return langMap[ep.resxCulture].Combobox_NoResults || langMap.en.Combobox_NoResults;
    },
    get Combobox_NoResultsMatch() {
        return langMap[ep.resxCulture].Combobox_NoResultsMatch || langMap.en.Combobox_NoResultsMatch;
    },
    get confirmation_description_dependent_date() {
        return langMap[ep.resxCulture].confirmation_description_dependent_date || langMap.en.confirmation_description_dependent_date;
    },
    get confirmation_title_dependent_date() {
        return langMap[ep.resxCulture].confirmation_title_dependent_date || langMap.en.confirmation_title_dependent_date;
    },
    get Cost_Text() {
        return langMap[ep.resxCulture].Cost_Text || langMap.en.Cost_Text;
    },
    get CreateAndSelect() {
        return langMap[ep.resxCulture].CreateAndSelect || langMap.en.CreateAndSelect;
    },
    get CustomerLabel() {
        return langMap[ep.resxCulture].CustomerLabel || langMap.en.CustomerLabel;
    },
    get day_template() {
        return langMap[ep.resxCulture].day_template || langMap.en.day_template;
    },
    get Duration_Text() {
        return langMap[ep.resxCulture].Duration_Text || langMap.en.Duration_Text;
    },
    get EditProjectMembers_Title() {
        return langMap[ep.resxCulture].EditProjectMembers_Title || langMap.en.EditProjectMembers_Title;
    },
    get EditTaskAssignees_Title() {
        return langMap[ep.resxCulture].EditTaskAssignees_Title || langMap.en.EditTaskAssignees_Title;
    },
    get End_Text() {
        return langMap[ep.resxCulture].End_Text || langMap.en.End_Text;
    },
    get EndDate_Text() {
        return langMap[ep.resxCulture].EndDate_Text || langMap.en.EndDate_Text;
    },
    get EstimatedHours_Text() {
        return langMap[ep.resxCulture].EstimatedHours_Text || langMap.en.EstimatedHours_Text;
    },
    get EstimatedHours_Total_Text() {
        return langMap[ep.resxCulture].EstimatedHours_Total_Text || langMap.en.EstimatedHours_Total_Text;
    },
    get field_for_all_activities() {
        return langMap[ep.resxCulture].field_for_all_activities || langMap.en.field_for_all_activities;
    },
    get field_for_issues() {
        return langMap[ep.resxCulture].field_for_issues || langMap.en.field_for_issues;
    },
    get field_for_projects() {
        return langMap[ep.resxCulture].field_for_projects || langMap.en.field_for_projects;
    },
    get field_for_requests() {
        return langMap[ep.resxCulture].field_for_requests || langMap.en.field_for_requests;
    },
    get field_for_tasks() {
        return langMap[ep.resxCulture].field_for_tasks || langMap.en.field_for_tasks;
    },
    get Hours_Short_Text() {
        return langMap[ep.resxCulture].Hours_Short_Text || langMap.en.Hours_Short_Text;
    },
    get HoursLeftLabel() {
        return langMap[ep.resxCulture].HoursLeftLabel || langMap.en.HoursLeftLabel;
    },
    get InternalCost_Text() {
        return langMap[ep.resxCulture].InternalCost_Text || langMap.en.InternalCost_Text;
    },
    get NonProjectMembers_Text() {
        return langMap[ep.resxCulture].NonProjectMembers_Text || langMap.en.NonProjectMembers_Text;
    },
    get Not_Space_Members() {
        return langMap[ep.resxCulture].Not_Space_Members || langMap.en.Not_Space_Members;
    },
    get Overloaded_Text() {
        return langMap[ep.resxCulture].Overloaded_Text || langMap.en.Overloaded_Text;
    },
    get OwnActualHours_Text() {
        return langMap[ep.resxCulture].OwnActualHours_Text || langMap.en.OwnActualHours_Text;
    },
    get PlannedExpenses_Text() {
        return langMap[ep.resxCulture].PlannedExpenses_Text || langMap.en.PlannedExpenses_Text;
    },
    get PortfolioLabel() {
        return langMap[ep.resxCulture].PortfolioLabel || langMap.en.PortfolioLabel;
    },
    get Progress() {
        return langMap[ep.resxCulture].Progress || langMap.en.Progress;
    },
    get ProgressCalculatedBySubActivities() {
        return langMap[ep.resxCulture].ProgressCalculatedBySubActivities || langMap.en.ProgressCalculatedBySubActivities;
    },
    get ProjectChildrenActualHours_Text() {
        return langMap[ep.resxCulture].ProjectChildrenActualHours_Text || langMap.en.ProjectChildrenActualHours_Text;
    },
    get ProjectChildrenEstimatedHours_Text() {
        return langMap[ep.resxCulture].ProjectChildrenEstimatedHours_Text || langMap.en.ProjectChildrenEstimatedHours_Text;
    },
    get ProjectMembers_Text() {
        return langMap[ep.resxCulture].ProjectMembers_Text || langMap.en.ProjectMembers_Text;
    },
    get ProjectOwnBudget_Text() {
        return langMap[ep.resxCulture].ProjectOwnBudget_Text || langMap.en.ProjectOwnBudget_Text;
    },
    get ProjectOwnEstimatedHours_Text() {
        return langMap[ep.resxCulture].ProjectOwnEstimatedHours_Text || langMap.en.ProjectOwnEstimatedHours_Text;
    },
    get ProjectSubactivitiesBudget_Text() {
        return langMap[ep.resxCulture].ProjectSubactivitiesBudget_Text || langMap.en.ProjectSubactivitiesBudget_Text;
    },
    get Space_Members() {
        return langMap[ep.resxCulture].Space_Members || langMap.en.Space_Members;
    },
    get Start_Text() {
        return langMap[ep.resxCulture].Start_Text || langMap.en.Start_Text;
    },
    get StartDate_Text() {
        return langMap[ep.resxCulture].StartDate_Text || langMap.en.StartDate_Text;
    },
    get Teams_Text() {
        return langMap[ep.resxCulture].Teams_Text || langMap.en.Teams_Text;
    },
    get Timelogs_In_Past() {
        return langMap[ep.resxCulture].Timelogs_In_Past || langMap.en.Timelogs_In_Past;
    },
    get Timelogs_In_Past_Short() {
        return langMap[ep.resxCulture].Timelogs_In_Past_Short || langMap.en.Timelogs_In_Past_Short;
    },
    get TimeLogs_Warning_Project_Closed() {
        return langMap[ep.resxCulture].TimeLogs_Warning_Project_Closed || langMap.en.TimeLogs_Warning_Project_Closed;
    },
    get TimeLogs_Warning_Project_Closed_Short() {
        return langMap[ep.resxCulture].TimeLogs_Warning_Project_Closed_Short || langMap.en.TimeLogs_Warning_Project_Closed_Short;
    },
    get TimeLogs_Warning_Task_Closed() {
        return langMap[ep.resxCulture].TimeLogs_Warning_Task_Closed || langMap.en.TimeLogs_Warning_Task_Closed;
    },
    get TimeLogs_Warning_Task_Closed_Short() {
        return langMap[ep.resxCulture].TimeLogs_Warning_Task_Closed_Short || langMap.en.TimeLogs_Warning_Task_Closed_Short;
    },
    get Tooltip_Dependent_Template() {
        return langMap[ep.resxCulture].Tooltip_Dependent_Template || langMap.en.Tooltip_Dependent_Template;
    },
    get Tooltip_HasChildren_Template() {
        return langMap[ep.resxCulture].Tooltip_HasChildren_Template || langMap.en.Tooltip_HasChildren_Template;
    },
    get Tooltip_ItemCompleted() {
        return langMap[ep.resxCulture].Tooltip_ItemCompleted || langMap.en.Tooltip_ItemCompleted;
    },
    get Tooltip_NoRightForUserRole_Template() {
        return langMap[ep.resxCulture].Tooltip_NoRightForUserRole_Template || langMap.en.Tooltip_NoRightForUserRole_Template;
    },
    get Tooltip_Open_Details() {
        return langMap[ep.resxCulture].Tooltip_Open_Details || langMap.en.Tooltip_Open_Details;
    },
    get undo_action_Project_UpdateActualCompletionDate() {
        return langMap[ep.resxCulture].undo_action_Project_UpdateActualCompletionDate || langMap.en.undo_action_Project_UpdateActualCompletionDate;
    },
    get undo_action_Project_UpdateDates() {
        return langMap[ep.resxCulture].undo_action_Project_UpdateDates || langMap.en.undo_action_Project_UpdateDates;
    },
    get undo_action_Project_UpdateName() {
        return langMap[ep.resxCulture].undo_action_Project_UpdateName || langMap.en.undo_action_Project_UpdateName;
    },
    get undo_action_Project_UpdateStatus() {
        return langMap[ep.resxCulture].undo_action_Project_UpdateStatus || langMap.en.undo_action_Project_UpdateStatus;
    },
    get undo_action_Task_UpdateActualCompletionDate() {
        return langMap[ep.resxCulture].undo_action_Task_UpdateActualCompletionDate || langMap.en.undo_action_Task_UpdateActualCompletionDate;
    },
    get undo_action_Task_UpdateDates() {
        return langMap[ep.resxCulture].undo_action_Task_UpdateDates || langMap.en.undo_action_Task_UpdateDates;
    },
    get undo_action_Task_UpdateDependencies() {
        return langMap[ep.resxCulture].undo_action_Task_UpdateDependencies || langMap.en.undo_action_Task_UpdateDependencies;
    },
    get undo_action_Task_UpdateName() {
        return langMap[ep.resxCulture].undo_action_Task_UpdateName || langMap.en.undo_action_Task_UpdateName;
    },
    get undo_action_Task_UpdateStatus() {
        return langMap[ep.resxCulture].undo_action_Task_UpdateStatus || langMap.en.undo_action_Task_UpdateStatus;
    },
    get undo_action_Task_UpdateWorkIsDone() {
        return langMap[ep.resxCulture].undo_action_Task_UpdateWorkIsDone || langMap.en.undo_action_Task_UpdateWorkIsDone;
    },
    get Untitled() {
        return langMap[ep.resxCulture].Untitled || langMap.en.Untitled;
    },
    get Validation_ActComplDateRange() {
        return langMap[ep.resxCulture].Validation_ActComplDateRange || langMap.en.Validation_ActComplDateRange;
    },
    get Validation_DateMandatory() {
        return langMap[ep.resxCulture].Validation_DateMandatory || langMap.en.Validation_DateMandatory;
    },
    get Validation_DurationMandatory() {
        return langMap[ep.resxCulture].Validation_DurationMandatory || langMap.en.Validation_DurationMandatory;
    },
    get Validation_EndDateRange() {
        return langMap[ep.resxCulture].Validation_EndDateRange || langMap.en.Validation_EndDateRange;
    },
    get Validation_FieldMandatory() {
        return langMap[ep.resxCulture].Validation_FieldMandatory || langMap.en.Validation_FieldMandatory;
    },
    get Validation_FromDateRange() {
        return langMap[ep.resxCulture].Validation_FromDateRange || langMap.en.Validation_FromDateRange;
    },
    get Validation_Interger() {
        return langMap[ep.resxCulture].Validation_Interger || langMap.en.Validation_Interger;
    },
    get Validation_InvalidDate() {
        return langMap[ep.resxCulture].Validation_InvalidDate || langMap.en.Validation_InvalidDate;
    },
    get Validation_NumberRange() {
        return langMap[ep.resxCulture].Validation_NumberRange || langMap.en.Validation_NumberRange;
    },
    get Validation_Range() {
        return langMap[ep.resxCulture].Validation_Range || langMap.en.Validation_Range;
    },
    get Validation_StartDateRange() {
        return langMap[ep.resxCulture].Validation_StartDateRange || langMap.en.Validation_StartDateRange;
    },
    get Validation_ToDateRange() {
        return langMap[ep.resxCulture].Validation_ToDateRange || langMap.en.Validation_ToDateRange;
    },
    get Validation_WeekendOrVacation() {
        return langMap[ep.resxCulture].Validation_WeekendOrVacation || langMap.en.Validation_WeekendOrVacation;
    },
    get Warning_UnassigneFromAllTasksInProject() {
        return langMap[ep.resxCulture].Warning_UnassigneFromAllTasksInProject || langMap.en.Warning_UnassigneFromAllTasksInProject;
    },
    get Warning_UnassignFromAllTasksInProject_Single() {
        return langMap[ep.resxCulture].Warning_UnassignFromAllTasksInProject_Single || langMap.en.Warning_UnassignFromAllTasksInProject_Single;
    },
};

// @ts-ignore
ep.resources = ep.resources || {};

// @ts-ignore
ep.resources.inlineEdit = inlineEditResx;
